<template>
    <div class="organization">
        <b-navbar type="dark">
            <b-container>
                <h2 class="p-3">{{currentUser.orgTitle}}</h2>

                <b-collapse is-nav class="hide-mobile">
                    <b-navbar-nav class="ml-auto">
                        <b-nav-item-dropdown right>
                            <template v-slot:button-content>
                                <em><i class="fas fa-user fa-sm mr-3"></i>{{currentUser.firstName}} {{currentUser.lastName}} </em>
                            </template>
                            <!--                            <b-dropdown-item href="#">Profile</b-dropdown-item>-->
                            <b-dropdown-item :to="{name: 'user-edit'}">Account Settings</b-dropdown-item>
                            <b-dropdown-item @click="doSignOut()">Sign Out</b-dropdown-item>
                        </b-nav-item-dropdown>
                    </b-navbar-nav>
                </b-collapse>
            </b-container>
        </b-navbar>

        <router-view/>

        <div class="show-on-mobile" style="margin-top: -100px">
            <b-container>
                <b-row>
                    <b-col>
                        <b-button block variant="light" @click="doSignOut()">Sign Out</b-button>
                    </b-col>
                </b-row>
            </b-container>
        </div>

        <footer class="mt-3 pb-2">
            <div>
                <router-link to="/"><img src="@/assets/logo-dark.png" class="logo mt-4"/></router-link>
            </div>

            <copyright variant="dark" class="mt-3 mb-4"/>
        </footer>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import Copyright from "../../components/Copyright";

    export default {
        name: "organization",
        components: {Copyright},
        computed: {
            ...mapGetters(['currentUser'])
        },
        methods: {
            ...mapActions(['signOut']),
            doSignOut() {
                this.signOut().then(() => {
                    this.$router.push('/login')
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';

    .organization {

        .navbar {
            background: linear-gradient(to bottom, darken($green, 8) 0%, $green 100%);
        }

        h2 {
            font-weight: normal;
            color: #ffffff;
            font-size: 22px
        }

        footer {
            text-align: center;

            .logo {
                max-height: 2.5rem;
            }
        }

        .hide-mobile {
            display: block
        }

        .show-on-mobile {
            display: none;
        }
    }

    @media only screen and (min-width: 320px) and (max-width: 736px) {
        .fixed-bottom {
            position: static !important;
        }
        .logo {
            width: 320px;
        }
    }

    @media screen and (max-width: 736px) {
        .hide-mobile {
            display: none !important;
        }
        .show-on-mobile {
            display: block
        }
    }

</style>
